/* eslint-env browser */
import * as React from 'react'

import withTranslator from '../../../client/clientjs/components/TranslatorProvider'

const PropTypes = require('prop-types')

const Table = require('../../../client/clientjs/components/Table')

class IndividualRankingTable extends React.Component {
  constructor(props) {
    super(props)

    const { ranking, usersCatches, round, translate } = props

    const rows = ranking
      .sort((a, b) => (a.score || 0) - (b.score || 0))
      .map(rank => ({
        ...rank,
        fishCatches: usersCatches[rank.userId] || [],
        round,
      }))

    const columns = [
      {
        name: 'rank',
        display: translate('ranking.rank'),
        getCellValue: row => row.rank,
        isSortable: true,
        isBold: true,
        isTextCentered: true,
      },
      {
        name: 'userName',
        display: '',
        getCellValue: row => (
          <span>
            {`${row.userFirstName} ${row.userLastName}`}&nbsp;
            <a href={`/users/${row.userId}`} target="_blank">
              <i className="fas fa-external-link" style={{ fontSize: '0.8em' }} />
            </a>
          </span>
        ),
        getCellRawValue: row => `${row.userFirstName} ${row.userLastName}`.toLowerCase(),
        isSortable: true,
      },
      {
        name: 'points',
        display: translate('ranking.roundPoints'),
        getCellValue: row => row.points,
        getCellSubRowValue: (row, subRow, subRowIdx) => {
          const fc = subRow
          return (
            <article className="media">
              <figure className="media-left">
                <p className="image is-64x64">
                  <a href={`/users/${fc.createdBy}/catches/${fc.id}`} target="_blank">
                    {fc.medias && fc.medias.length > 0 && (
                      <img
                        src={fc.medias[0].url_100}
                        height="50"
                        alt="fish catch"
                        className="has-object-fit-contain"
                        style={{ maxHeight: '100%' }}
                      />
                    )}
                  </a>
                </p>
              </figure>
              <div className="media-content">
                <div className="content is-size-7-tablet is-size-8-mobile">
                  {fc.speciesCustomName ||
                    (fc.fish && fc.fish.names && fc.fish.names.length ? fc.fish.names[0].value : '')}
                  <br />
                  {fc.size ? `${fc.size}cm` : ''}
                </div>
              </div>
            </article>
          )
        },
        isSortable: true,
        isBold: true,
        isTextCentered: true,
        isSubRowTextRight: true,
      },
      {
        name: 'score',
        display: `(${translate('ranking.roundScore')})`,
        getCellValue: row => row.score,
        getCellSubRowValue: (row, subRow, subRowIdx) => {
          const { keepOnlyTop } = row.round.settings || {}
          return !keepOnlyTop || subRowIdx < keepOnlyTop ? subRow.contestAsso.score : ''
        },
        isSortable: true,
        isTextCentered: true,
        isSubRowTextCentered: true,
      },
    ]

    this.state = {
      rows,
      columns,
    }

    this.onRowClick = this.onRowClick.bind(this)
  }

  onRowClick(row) {
    const { rows } = this.state

    const rowRankingIndex = rows.findIndex(elt => elt.userId === row.userId)

    if (rowRankingIndex === -1) {
      return
    }

    const rowRanking = rows[rowRankingIndex]

    rows[rowRankingIndex] = {
      ...rowRanking,
      isDisplayed: !rowRanking.isDisplayed,
    }

    this.setState({
      rows,
    })
  }

  render() {
    const { rows, columns } = this.state
    const { scoreLessIsMore } = this.props
    return (
      <Table
        rows={rows}
        columns={columns}
        defaultSortBy="points"
        defaultSortASC={scoreLessIsMore}
        getRowKey={row => row.userId}
        onRowClick={this.onRowClick}
        getSubRows={row => (row.isDisplayed ? row.fishCatches || [] : [])}
        getSubRowKey={(row, subRow) => row.userId + subRow.id}
        tableClass="is-size-7 is-size-8-mobile is-self-centered"
      />
    )
  }
}

IndividualRankingTable.propTypes = {
  translate: PropTypes.func.isRequired,
  ranking: PropTypes.array,
  usersCatches: PropTypes.object,
  round: PropTypes.object.isRequired,
  scoreLessIsMore: PropTypes.bool,
}

IndividualRankingTable.defaultProps = {
  ranking: [],
  usersCatches: {},
  scoreLessIsMore: false,
}

module.exports = withTranslator(IndividualRankingTable)
